const HEADER_NAME = "x-breaking-changes-count";

let knownCount: string | null = null;
let breakingChangesDetected = false;

export function hasBreakingChanges(): boolean {
  return breakingChangesDetected;
}

export function resetBreakingChangesState(): void {
  knownCount = null;
  breakingChangesDetected = false;
}

export function createBreakingChangesFetch(
  baseFetch: typeof fetch,
): typeof fetch {
  return async (input, init?) => {
    const response = await baseFetch(input, init);

    const count = response.headers.get(HEADER_NAME);
    if (count !== null) {
      if (knownCount === null) {
        knownCount = count;
      } else if (count !== knownCount) {
        breakingChangesDetected = true;
      }
    }

    return response;
  };
}
